module.exports = __webpack_public_path__ + "img/1-活码设置-03.56f8b1e4.png";